import { useQuery } from '@apollo/client'
import { useState } from 'react'

import { fromDTO } from './api/mapper/fromDTO'
import { GET_AB_TEST_PARAMETERS_SCHEMA } from './api/query'

import type { Props, UseGetAbTestParametersSchema } from './types'
import type { AbTestParametersSchema } from 'features/ab-tests/types/abTestParametersSchema'

export const useGetAbTestParametersSchema = ({ domainId }: Props): UseGetAbTestParametersSchema => {
  const [schema, setSchema] = useState<AbTestParametersSchema>()

  const { loading } = useQuery(GET_AB_TEST_PARAMETERS_SCHEMA, {
    onCompleted: ({ abTestParametersSchema }): void => {
      if (abTestParametersSchema) {
        setSchema(fromDTO(abTestParametersSchema))
      }
    },
    skip: !domainId,
    variables: { domainId },
  })

  return { loading, schema }
}
